// @ts-check
/// <reference path="../global.d.ts" />
// @preserve version: {{VERSION}}
// @preserve hash: {{HASH}}
/*

Ignition (https://www.ignitiontheme.com)
Section JS

*/

(function ignition_sections($, ignition) {
// MatchHeight

/**
 * @param {string} o
 */
ignition.to_handle = function to_handle(o) {
    return o.toLowerCase().replace(/[()]/g, '').replace(/[\W]/g, '-');
};

ignition.load_icons = function load_icons() {
    // If we use wrong icon, whole feather will crash and no further icons will be loaded
    // this will check if icons are valid and will remove the feather if not
    var icons = Object.keys(window.feather.icons);
    Array.prototype.forEach.call(
        document.querySelectorAll('[data-feather]'),
        function feather_foreach(el) {
            var icon = el.dataset.feather;
            if (icons.indexOf(icon) < 0) {
                console.warn('No such icon "' + icon + '" in feather, element', el); // eslint-disable-line no-console
                el.dataset.featherInvalid = icon;
                delete el.dataset.feather;
            }
        },
    );
    try {
        window.feather.replace();
    } catch (e) {
        console.error('Unable to load icons:', e); // eslint-disable-line no-console
    }
};

// Instagram section

ignition.INSTAGRAM_SELECTOR = '.instagram-wrapper';


// Workaround for bug in chrome causing first attempt to open dropdown to fail
// https://github.com/Dogfalo/materialize/issues/6322
$.fn.original_material_select = $.fn.material_select;
$.fn.material_select = function material_select() {
    $(this).original_material_select();
    Array.prototype.forEach.call(
        document.querySelectorAll('.select-wrapper'),
        function select_wrapper_each(t) {
            t.addEventListener('click', function select_wrapper_each_click(e) {
                e.stopPropagation();
            });
        },
    );
};

ignition.instagram_sort = function instagram_sort(data, sortKey) {
    var compareFn;
    switch (sortKey) {
        case 'none':
            compareFn = function compare_none(entry1, entry2) {
                return parseInt(entry2.created_time, 10) - parseInt(entry1.created_time, 10);
            };
            break;
        case 'most-liked':
            compareFn = function compare_most_liked(entry1, entry2) {
                return entry2.likes.count - entry1.likes.count;
            };
            break;
        case 'most-commented':
            compareFn = function compare_most_commented(entry1, entry2) {
                return entry2.comments.count - entry1.comments.count;
            };
            break;
        case 'random':
            compareFn = function compare_random() {
                return Math.random() > 0.5;
            };
            break;
        default:
            console.error('Invalid sort key', sortKey); // eslint-disable-line no-console
    }
    data.sort(compareFn);
};

ignition.instagram_fetch = function instagram_fetch(url, results, count, callback) {
    $.ajax({
        url: url + '&callback=?',
        crossDomain: true,
        dataType: 'jsonp',
    })
        .done(function instagram_fetch_done(data) {
            var entries = data.data;
            entries.forEach(function instagram_fetch_done_entry(entry) {
                if (results.length >= count) {
                    return;
                }
                if (entry.type !== 'image') {
                    return;
                }
                results.push(entry);
            });
            if (results.length < count && data.pagination && data.pagination.next_url) {
                return instagram_fetch(data.pagination.next_url, results, count, callback);
            } else {
                return callback(results, null);
            }
        })
        .fail(function instagram_fetch_fail(jqXHR) {
            var errorMessage;
            try {
                errorMessage = jqXHR.responseJSON.meta.error_message;
            } catch (e) {
                errorMessage = 'Unknown error';
            }
            return callback(results, errorMessage);
        });
};

ignition.instagram_init = function instagram_init(instagram_element) {
    var section = instagram_element.dataset.id;

    // Read the Instagram token
    /** @type HTMLInputElement */
    var token_input = document.querySelector('#token-' + section);
    if (!token_input) {
        // We don't have a token, no data are available and placeholder is shown
        return;
    }
    var token = token_input.value;

    // Set up options for Instafeed
    /** @type HTMLElement */
    var target = document.querySelector('#instafeed-' + section);
    var rows = parseInt(target.dataset.rows, 10),
        grid = parseInt(target.dataset.grid, 10),
        sortBy = target.dataset.sortBy,
        count = rows * grid,
        $target = $(target);

    // Instagram paginates the data and filters out private images after getting required `count`.
    // we'll requests many more images than needed, but will be paginated anyway, so we'll read
    // as many pages as needed for requested number of images
    var url = 'https://api.instagram.com/v1/users/self/media/recent?access_token=' + token + '&count=1000';
    ignition.instagram_fetch(url, [], count, function instagram_fetch_done(results, errorMessage) {
        if (errorMessage) {
            if (window.Shopify.designMode) {
                $target.empty();
                $target.css('position', 'relative');
                $('<div class="instagram-container-error"></div>').text(errorMessage).appendTo($target);

                var placeholder = document.querySelector('#instagram-placeholder').textContent;
                for (var i = 0; i < count; i += 1) {
                    $(placeholder).appendTo($target);
                }
            } else {
                $target.closest('.homepage-section--instagram-wrapper').hide();
            }

            console.error('Unable to load instagram data:', errorMessage); // eslint-disable-line no-console
        } else {
            $target.empty();
            $target.closest('.homepage-section--instagram-wrapper').show();
            ignition.instagram_sort(results, sortBy);
            results.forEach(function instagram_foreach(entry) {
                var image = entry.images;
                var div = document.createElement('div');
                div.classList.add('instagram-indiv');
                div.classList.add('instagram-grid-' + grid);
                var link = document.createElement('a');
                link.href = entry.link;
                link.target = '_blank';
                var img = document.createElement('img');
                img.src = image.thumbnail.url;
                img.dataset.src = image.thumbnail.url;
                img.dataset.srcset = (
                    image.thumbnail.url + ' ' + image.thumbnail.width + 'w, ' +
                    image.low_resolution.url + ' ' + image.low_resolution.width + 'w,' +
                    image.standard_resolution.url + ' ' + image.standard_resolution.width + 'w'
                );
                img.dataset.sizes = 'auto';
                img.classList.add('lazyload');
                img.classList.add('instagram-image');
                div.appendChild(link);
                link.appendChild(img);
                target.appendChild(div);
            });
        }
    });
};

ignition.load_instagram = function load_instagram(target) {
    var instagram_elements = target.querySelectorAll(ignition.INSTAGRAM_SELECTOR);
    Array.prototype.forEach.call(instagram_elements, ignition.instagram_init);
};

// Slider section

ignition.SLIDER_SELECTOR = '.flexslider-homepage';
ignition.SLIDER_REENABLE_INTERVAL = 6000;

ignition.Slider = function Slider(element, options) {
    this.$element = $(element);
    this.playing = false;

    this.configure(options || {});

    // flexslider stops the animation when the page is not focused, this breaks when the section is
    // changed in theme admin because it triggers 'blur' event when another iframe is selected
    $(window).off('blur');
};


ignition.Slider.prototype.get_speed = function slider_get_speed() {
    return parseInt(this.$element.data('sliderSlideTime'), 10);
};

ignition.Slider.prototype.get_id = function slider_get_id() {
    return this.$element.data('sliderId');
};

ignition.Slider.prototype.get_animation = function slider_get_animation() {
    return this.$element.data('sliderAnimation');
};

ignition.Slider.prototype.show_slide = function slider_show_slide(index) {
    this.$element.flexslider(index);
    if (this.get_speed() > 0) {
        this.playing = false;
        this.$element.flexslider('pause');
    }
};

ignition.Slider.prototype.start_animation = function slider_start_animation() {
    // Don't start animation when autorotate is disabled
    if (this.get_speed() > 0) {
        this.playing = true;
        this.$element.flexslider('play');
    }
};

ignition.Slider.prototype.on_slide_change = function slider_on_slide_change(slider) {
    var speed = this.get_speed();
    if (this.playing && !slider.playing && speed > 0) {
        // restart autoscroll after given interval since last interaction
        clearTimeout(this.restartTimer);
        this.restartTimer = setTimeout(function slider_on_restart() {
            slider.play();
        }, Math.max(0, ignition.SLIDER_REENABLE_INTERVAL - speed));
    }
};

ignition.Slider.prototype.configure = function slider_configure(options) {
    if ($(window).width() === 0) {
        // the app is not yet loaded in the admin, retry later
        setTimeout(this.configure.bind(this), 200);
        return;
    }
    var speed = this.get_speed();
    var id = this.get_id();

    var $container = $('.slider-pagination-container.slider--' + id);
    var $nav = $('.flex-direction-nav.slider--' + id + ' a');

    var opts = $.extend({}, {
        slideshowSpeed: speed,
        animation: this.get_animation(),
        controlsContainer: $container,
        customDirectionNav: $nav,
        slideshow: speed > 0,
        pauseOnAction: true,
        after: this.on_slide_change.bind(this),
        controlNav: $container.length > 0,
        directionNav: $nav.length > 0,
        startAt: 0,
    }, options);
    this.$element.find('ul.slides').width('auto');
    this.$element.flexslider(opts);
    this.playing = true;
};

/* Mapping from sectionId to Slider instance */
ignition.sliders = {};

/* Initialize all the sliders */
ignition.load_slider = function load_slider(section) {
    ignition.sliders = {};
    section = section || document;
    var slider_elements = section.querySelectorAll(ignition.SLIDER_SELECTOR);
    Array.prototype.forEach.call(slider_elements, function slider_foreach(slider_element) {
        // Prevent flickering in the flexslider by setting fixed width of the slides
        $(slider_element).find('.slides li').css('width', $(slider_element).width());

        ignition.sliders[slider_element.dataset.sliderId] = new ignition.Slider(slider_element);
    });
};

/* Mapping from sectionId to Testimonial instance */
ignition.testimonials = {};

/* Initialize all the testimonials */
ignition.load_testimonial = function load_testimonial(section) {
    ignition.testimonials = {};
    section = section || document;
    var slider_elements = section.querySelectorAll('.flexslider-homepage-testimonial');
    Array.prototype.forEach.call(slider_elements, function testimonial_foreach(slider_element) {
        // Prevent flickering in the flexslider by setting fixed width of the slides
        $(slider_element).find('.slides li').css('width', $(slider_element).width());

        ignition.testimonials[slider_element.dataset.sliderId] = new ignition.Slider(slider_element);
    });
};

/* Mapping from sectionId to Announcement instance - there will be only one but we need it
   to distinguish from other sliders. */
ignition.announcements = {};

ignition.load_announcement_bar = function load_announcement_bar() {
    /** @type HTMLElement */
    var el = document.querySelector('.announcement-bar--slider');
    if (!el) {
        return;
    }
    ignition.announcements[el.dataset.sliderId] = new ignition.Slider(el, {
        controlNav: false,
    });
};

// Product template section

ignition.load_tabs = function load_tabs() {
    $('ul.tabs').each(function tab_foreach() {
        var $this = $(this);
        var links = $this.find('a');
        var active = links.first().addClass('active');
        var content = $(active.attr('href'));
        links.not(':first').each(function tab_link_foreach() {
            $($this.attr('href')).hide();
        });
        $this.find('a').on('click', function tab_link_click() {
            active.removeClass('active');
            content.hide();
            active = $this;
            content = $($this.attr('href'));
            active.addClass('active');
            content.fadeIn();
            return false;
        });
    });
};

ignition.apply_zoom = function apply_zoom(target) {
    var $target = $(target);
    var img = $target.find('img')[0];
    var duration = 120;
    var timer = null;
    $target.zoom({
        url: img.dataset.zoomImg || img.src,
        touch: false,
        duration: duration,
        onZoomIn: function on_zoom_in() {
            // Hide zoomed image when it's smaller then parent div,
            // it would just move but there won't be any zoom
            if ($target.width() >= $(this).width()) {
                $target.find('.zoomImg').addClass('hide');
                return;
            } else {
                $target.find('.zoomImg').removeClass('hide');
            }

            // Hide image when zoomed image is hovered - to prevent
            // both images visible when the image is too small
            timer = setTimeout(function apply_zoom_timer() {
                img.classList.add('product-image-hidden');
                timer = null;
            }, duration);
        },
        onZoomOut: function on_zoom_out() {
            if (timer) {
                clearTimeout(timer);
            }
            img.classList.remove('product-image-hidden');
        },
    });
};

ignition.load_zoom = function load_zoom() {
    $('*[data-zoom=true]').each(function load_zoom_foreach() {
        ignition.apply_zoom(this);
    });
};

ignition.format_money = function format_money(cents, format) {
    var moneyFormat = ignition.moneyFormat; // eslint-disable-line camelcase
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
        if (precision === null || precision === undefined) {
            precision = 2;
        }
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number == null) { // eslint-disable-line no-restricted-globals
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        var centsAmount = parts[1] ? (decimal + parts[1]) : '';

        return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        default:
            throw new Error('Invalid money format' + formatString);
    }

    return '<span class="money">' + formatString.replace(placeholderRegex, value) + '</span>';
};

function Product(element) {
    // Settings
    this.config = {
        shopify_ajax_add_url: '/cart/add.js',
        shopify_ajax_url: '/cart.js',
    };

    this.element = element;
    this.$element = $(element);

    this.sectionId = this.element.dataset.sectionId;
    var product_script = document.querySelector('#ProductJson-' + this.sectionId);
    if (!product_script) {
        // Product is not loaded, there is either no product section or the product is not selected
        return;
    }
    /** @type HTMLElement */
    var json_element = document.querySelector('#ProductJson-' + this.sectionId);
    this.product = JSON.parse(json_element.innerText);
    this.$selects = this.$element.find('.selector-wrapper select, .materialize-select select');
    this.$selects.on('change', this.on_select_change.bind(this));
    this.$original_select = this.$element.find('.original-select');
    this.$price = this.$element.find('#price-field');
    this.$cart = this.$element.find('#purchase');
    this.$spb = this.$element.find('.shopify-payment-button');
    this.$sale = this.$element.find('.sale-badge,.compare-at-price');
    this.$sale_price = this.$element.find('.compare-at-price');
    this.$variant_percentage_wrapper = this.$element.find('.variant-percentage-wrapper');
    this.$variant_value_wrapper = this.$element.find('.variant-value-wrapper');
    this.$featured_image_wrapper = this.$element.find('.featured-image-div');
    this.$featured_image = this.$element.find('.product-main-image');
    this.$add_to_cart_form = this.$element.find('#add-to-cart-form');
    this.$mobile_slider = this.$element.find('.mobile-product-slider');
    this.$cart_slider_wrapper = $('#cartSlideoutWrapper');
    this.$thumbnail_wrapper = this.$element.find('.product-thumbnails-wrapper');
    this.$thumbnails = this.$thumbnail_wrapper.find('a.image-swap');
    this.$swatch_inputs = this.$element.find('#add-to-cart-form').find('.swatch input');
    this.$sku = this.$element.find('.indiv-product-sku-text');
    this.thumbnail_changes_variant = this.$element.find('#thumbnail_changes_variant').val() === 'true';
    this.added_text_timeout = null;
    this.is_variant_switch_manual = false;

    if (this.$swatch_inputs.length > 0) {
        // Check swatched based on variant
        this.on_swatch_change();
    } else {
        // Fill variant based on selection
        this.on_select_change();
    }
    this.$cart.on('click', function product_cart_click(e) {
        e.preventDefault();
        this.disable_cart_button();
        this.add_to_cart();
    }.bind(this));

    // Change product (if enabled) when thumbnail is clicked
    this.$thumbnails.on('click', function product_thumbnails_click(e) {
        this.on_thumbnail_click(e.currentTarget);
        return false;
    }.bind(this));

    this.$swatch_inputs.on('change', this.on_swatch_change.bind(this));

    // Change product (if enabled) when slider changes (on mobile and in quick shop section)
    var slider = this.$mobile_slider.data('flexslider');
    if (!slider) {
        return;
    }
    var old_after = slider.vars.after;
    slider.vars.after = function product_slider_after() {
        old_after();
        if (!this.is_variant_switch_manual) {
            this.on_mobile_slider_change();
        }
        this.is_variant_switch_manual = false;
    }.bind(this);
}

ignition.Product = Product;

ignition.is_video_link = function is_video_link(link) {
    return link && (link.indexOf('youtube.com/embed') >= 0 || link.indexOf('player.vimeo.com') >= 0);
};

Product.prototype.set_featured_image = function set_featured_image($newImage) {
    var alt = $newImage.attr('alt');
    var is_video = ignition.is_video_link(alt);
    if (is_video) {
        var video = $('<iframe frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>').attr('src', alt);
        var wrapped = $('<div class="video-wrapper product-main-image">').append(video);
        this.$featured_image.replaceWith(wrapped);
        this.$featured_image = wrapped;
        this.$featured_image_wrapper.find('.zoomImg').remove();
        this.$featured_image_wrapper.removeClass('zoom--cross-hair');
    } else {
        var clone = $newImage.clone().removeClass('lazyloaded').addClass('lazyload product-main-image');
        this.$featured_image.replaceWith(clone);
        this.$featured_image = clone;
        this.$featured_image_wrapper.find('.zoomImg').remove();
        var has_zoom = this.$featured_image_wrapper.parent('#product_images').hasClass('product-image-zoom');
        if (has_zoom) {
            this.$featured_image_wrapper.addClass('zoom--cross-hair').removeClass('video');
            ignition.apply_zoom(this.$featured_image_wrapper);
        }
    }
};

Product.prototype.set_variant_options = function set_variant_options(values) {
    var matching_variants = this.product.variants.filter(function set_variant_options_filter(variant) {
        for (var i = 0; i < values.length; i += 1) {
            if (values[i] !== variant.options[i]) {
                return false;
            }
        }
        return true;
    });
    if (matching_variants.length === 0) {
        this.update_variant(null);
    } else {
        this.update_variant(matching_variants[0]);
    }
};

Product.prototype.on_select_change = function on_select_change() {
    var values = this.$selects.map(function on_select_change_map(index, select) {
        return $(select).val();
    });
    this.set_variant_options(values);
};

Product.prototype.on_swatch_change = function on_swatch_change() {
    var values = [];
    this.$add_to_cart_form.serializeArray().forEach(function on_swatch_change_foreach(option) {
        if (option.name.indexOf('option-') === 0) {
            values[parseInt(option.name.split('-')[1], 10)] = option.value;
        }
    });
    this.set_variant_options(values);
};

Product.prototype.on_thumbnail_click = function on_thumbnail_click(thumbnail) {
    // swap image
    var $thumbnail = $(thumbnail);
    var newImage = $thumbnail.find('img').eq(0);
    this.set_featured_image(newImage);

    // select variant
    if (this.thumbnail_changes_variant) {
        var variant_id = $thumbnail.data('variant');
        if (variant_id) {
            this.on_variant_selected(variant_id);
        }
    }
};

Product.prototype.on_mobile_slider_change = function on_mobile_slider_change() {
    var variant_id = this.$mobile_slider.find('.flex-active-slide img').data('variant');
    if (variant_id) {
        this.on_variant_selected(variant_id);
    }
};

Product.prototype.on_variant_selected = function on_variant_selected(variant_id) {
    var matching_variants = this.product.variants.filter(function on_variant_selected_filter(variant) {
        return variant.id === variant_id;
    });
    if (matching_variants.length === 0) {
        this.update_variant(null);
    } else {
        var variant = matching_variants[0];
        this.update_variant(matching_variants[0]);
        for (var i = 0; i < variant.options.length; i += 1) {
            this.$element.find('#SingleOptionSelector-' + i).val(variant.options[i]).material_select();
        }
    }
};

Product.prototype.update_variant = function update_variant(variant) {
    if (variant) {
        this.$original_select.val(variant.id);

        var is_sale = variant.compare_at_price && variant.compare_at_price > variant.price;
        this.$sale.toggleClass('hide', !is_sale);
        if (variant.sku) {
            this.$sku.text(variant.sku);
        }
        this.$sku.toggleClass('hide', !variant.sku);

        if (!variant.available) {
            this.$price.text(ignition.strings.soldOut);
            this.$sale_price.text('');
            this.$cart.prop('disabled', true);
            this.$spb.css({ opacity: 1 }).animate({ opacity: 0 }).hide();
            this.$cart.text(ignition.strings.soldOut);
            if (this.$variant_percentage_wrapper.length > 0) {
                this.$variant_percentage_wrapper.addClass('hide');
            } else if (this.$variant_value_wrapper.length > 0) {
                this.$variant_value_wrapper.addClass('hide');
            }
            $.event.trigger({
                type: 'variantUnavailable',
                time: new Date(),
                variant: variant,
            });
        } else {
            this.$price.html(ignition.format_money(variant.price));
            this.$sale_price.html(is_sale ? ignition.format_money(variant.compare_at_price) : '');
            this.$cart.prop('disabled', false);
            this.$spb.show().css({ opacity: 1 }).animate({ opacity: 1 });
            this.$cart.text(ignition.strings.addToCart);
            if (this.$variant_percentage_wrapper.length > 0 && variant.compare_at_price > variant.price) {
                this.$variant_percentage_wrapper.removeClass('hide');
                var percentage = (variant.compare_at_price - variant.price) * 100.0 / variant.compare_at_price;
                this.$variant_percentage_wrapper.find('.variant-percentage').text(percentage.toFixed(0) + '%');
            } else {
                this.$variant_percentage_wrapper.addClass('hide');
            }
            if (this.$variant_value_wrapper.length > 0 && variant.compare_at_price > variant.price) {
                this.$variant_value_wrapper.removeClass('hide');
                var value = variant.compare_at_price - variant.price;
                this.$variant_value_wrapper.find('.variant-value').html(ignition.format_money(value));
            } else {
                this.$variant_value_wrapper.addClass('hide');
            }

            $.event.trigger({
                type: 'variantAvailable',
                time: new Date(),
            });
        }
        if (variant.featured_image) {
            var $thumbnail = this.$thumbnail_wrapper.find('[data-image-id="' + variant.featured_image.id + '"] img');
            if ($thumbnail.length > 0) {
                this.set_featured_image($thumbnail);
            }

            var slider = this.$element.find('.mobile-product-slider');
            if (slider.length === 0) {
                slider = this.$element.find('.homepage-sections--indiv-product-slider');
            }
            var li_to_activate = slider.find('li:not(.clone) [data-image-id="' + variant.featured_image.id + '"]').parent();
            var index = slider.data('flexslider').slides.index(li_to_activate);
            if (index > -1) {
                this.is_variant_switch_manual = true;
                slider.flexslider(index);
            }
        }

        var is_indiv_product = this.$element.closest('.shopify-section').hasClass('homepage-section--indiv-product-wrapper');
        var has_more_variants = this.product.variants.length > 1;
        if (window.history.replaceState && !is_indiv_product && has_more_variants) {
            // Change url to include variant if we're not on homepage
            var search = [];
            if (window.location.search.length > 1) {
                // select non-variant query params
                search = window.location.search.slice(1).split('&').filter(function location_search(q) {
                    return q.indexOf('variant=') !== 0;
                });
            }
            // add current variant
            search.push('variant=' + variant.id);

            // set the url to include the variant
            var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?' + search.join('&');
            window.history.replaceState({ path: newurl }, '', newurl);
        }

        // Swatches
        if (this.$swatch_inputs.length > 0) {
            var section_id = this.$element.data('section-id');
            variant.options.forEach(function variant_options_foreach(option, i) {
                this.$swatch_inputs.filter('#section-' + section_id + '-swatch-' + i + '-' + ignition.to_handle(option)).prop('checked', true);
            }.bind(this));
        }
    } else {
        var make_a_selection = this.$selects.filter(function selects_fitler(i, select) {
            return $(select).val() === '';
        }).length > 0;
        if (make_a_selection) {
            this.$price.text(ignition.strings.make_a_selection);
        } else {
            this.$price.text(ignition.strings.unavailable);
        }
        this.$cart.prop('disabled', true);
        this.$sale.addClass('hide');
        this.$variant_percentage_wrapper.addClass('hide');
        this.$variant_value_wrapper.addClass('hide');
        this.$sku.addClass('hide');
    }
    if (window.Currency && window.Currency.shopCurrency) {
        window.Currency.convertAll(window.Currency.shopCurrency, window.Currency.currentCurrency);
    }
};

ignition.CART_LOADING = '<div class="lds-dual-ring"></div><span class="sr-only">Loading...</span>';

Product.prototype.add_to_cart = function add_to_cart() {
    this.clear_error();

    $.ajax({
        url: this.config.shopify_ajax_add_url,
        dataType: 'json',
        type: 'post',
        data: this.$add_to_cart_form.serialize(),
        success: this.added_to_cart.bind(this),
        error: this.add_to_cart_failed.bind(this),
    });
};

Product.prototype.disable_cart_button = function disable_cart_button() {
    if (this.added_text_timeout) {
        clearTimeout(this.added_text_timeout);
        this.added_text_timeout = null;
    }
    this.$cart.addClass('disabled').prop('disabled', true).html(ignition.CART_LOADING);
};

Product.prototype.enable_cart_button = function enable_cart_button() {
    if (this.added_text_timeout) {
        clearTimeout(this.added_text_timeout);
        this.added_text_timeout = null;
    }
    this.$cart.removeClass('disabled').prop('disabled', false).html(ignition.strings.addToCart);
};

Product.prototype.added_to_cart = function added_to_cart() {
    this.update_cart();
};

Product.prototype.open_cart_page = function open_cart_page() {
    window.location.href = '/cart';
};

Product.prototype.show_cart = function show_cart() {
    this.$cart_slider_wrapper.trigger('cart:open');
};

Product.prototype.update_cart = function update_cart() {
    // Update cart count
    $.getJSON(this.config.shopify_ajax_url)
        .then(this.updated_cart.bind(this))
        .fail(this.update_cart_failed.bind(this));
};

Product.prototype.updated_cart = function updated_cart(data) {
    ignition.update_cart_drawer(data);
    this.enable_cart_button();

    var cart_action = this.$cart.data('cart-action');
    if (cart_action === 'cart') {
        this.open_cart_page();
    } else if (cart_action === 'added') {
        this.$cart.html(ignition.strings.added);
        if (this.added_text_timeout) {
            clearTimeout(this.added_text_timeout);
            this.added_text_timeout = null;
        }
        this.added_text_timeout = setTimeout(function added_text_timeout() {
            this.$cart.html(ignition.strings.addToCart);
        }.bind(this), 2000);
    } else {
        // cart_action === drawer
        this.show_cart();
    }
};

Product.prototype.update_cart_failed = function update_cart_failed(response) {
    this.enable_cart_button();
    console.error('Updating the cart failed: ', response); // eslint-disable-line no-console
};

Product.prototype.add_to_cart_failed = function add_to_cart_failed(response) {
    this.enable_cart_button();
    var errorText = 'Unknown error';
    if (response.status === 0) {
        // Unable to connect to server
    } else if (response.responseJSON) {
        // Process JSON error
        if (response.responseJSON.description) {
            errorText = response.responseJSON.description;
        } else {
            errorText = response.responseJSON.message;
        }
    } else if (response.responseText) {
        // Use plain text error
        errorText = response.responseText;
    }
    this.show_error(errorText);
};

Product.prototype.show_error = function show_error(text) {
    $('<div id="cart-error"></div>')
        .addClass('alert alert-danger')
        .text(text)
        .insertAfter(this.$cart);
};

Product.prototype.clear_error = function clear_error() {
    $('#cart-error').remove();
};

ignition.products = [];

ignition.load_product = function load_product(target) {
    if (target) {
        ignition.products.push(new ignition.Product(target.querySelector('#product-box')));
    } else {
        Array.prototype.forEach.call(document.querySelectorAll('#product-box'), function load_product_each(box) {
            ignition.products.push(new ignition.Product(box));
        });
    }
};

ignition.FADE_OUT_ANIMATION_DURATION = 800; // ms

ignition.update_cart_drawer = function update_cart_drawer(data) {
    $('.cart-error-box').text('');

    if (data.items.length === 0) {
        $('.cart-empty-box,.ajax-cart--total-price').removeClass('hide');
        $('.ajax-cart--total-price,.cart-button-checkout').addClass('hide');
    } else {
        $('.cart-empty-box').addClass('hide');
        $('.ajax-cart--total-price,.cart-button-checkout').removeClass('hide');
    }

    var template = $('#cart-item-template').html();
    var $cart_items = $('.cart-items');
    $cart_items.empty();
    data.items.forEach(function update_cart_drawer_foreach(item) {
        var $cart_item = $(template);
        if (item.image) {
            $cart_item.find('.cart-item-image').attr({
                src: item.image,
                alt: item.product_title,
            });
        } else {
            $cart_item.find('.cart-item-image').css('display', 'none');
        }
        $cart_item.find('.cart-item-link').attr({
            href: item.url,
        });
        $cart_item.find('.cart-item-product-title').text(item.product_title);
        $cart_item.find('.cart-item-variant-title').text(item.variant_title);
        $cart_item.find('.cart-item-price').html(ignition.format_money(item.line_price));
        var $quantity = $cart_item.find('.cart-item-quantity');
        var quantity_wrapper = $quantity.closest('.cart-item--quantity-wrapper');
        var update_quantity = function update_quantity(quantity) {
            quantity_wrapper.addClass('cart-item-quantity-active');
            var fade = quantity <= 0;
            var delay = fade ? ignition.FADE_OUT_ANIMATION_DURATION : 0;
            ignition.cart_set_quantity(delay).always(function cart_set_quantity_always() {
                quantity_wrapper.removeClass('cart-item-quantity-active');
                if (fade) {
                    $cart_item.addClass('fadeOut animated fast');
                    setTimeout($cart_item.remove, ignition.FADE_OUT_ANIMATION_DURATION);
                }
            });
        };
        $quantity.on('change', function quantity_change() {
            var new_q = parseInt($(this).val().toString(), 10);
            update_quantity(new_q);
        });
        $quantity.val(item.quantity);
        $quantity.attr('name', 'updates[' + item.variant_id + ']');

        $cart_item.find('.cart-item-quantity-button').on('click', function quantity_button_click() {
            var current = parseInt($quantity.val().toString(), 10);
            var change = parseInt(this.dataset.amount, 10);
            var new_q = current + change;
            $quantity.val(new_q);
            update_quantity(new_q);
        });
        $cart_item.appendTo($cart_items);
    });

    $('.cart-item-count, .cart-item-count-header--quantity').text(data.item_count);
    $('.cart-item-total-price, .cart-item-count-header--total').html(ignition.format_money(data.total_price));
    if (window.Currency && window.Currency.shopCurrency) {
        window.Currency.convertAll(window.Currency.shopCurrency, $('[name=currencies]').val().toString());
    }
};

ignition.cart_set_quantity = function cart_set_quantity(delay) {
    var deferred = $.Deferred();

    $('.cart-error-box').text('');

    $.ajax({
        type: 'POST',
        url: '/cart/update.js',
        dataType: 'json',
        data: $('.cart-drawer-form').serialize(),
    })
        .then(function cart_set_quantity_then(data) {
            deferred.resolve();
            setTimeout(function cart_set_quantity_then_timer() {
                ignition.update_cart_drawer(data);
            }, delay);
        })
        .fail(function cart_set_quantity_fail(jqXHR, textStatus, errorThrown) {
            deferred.reject();
            console.error('Cart error', textStatus, jqXHR, errorThrown); // eslint-disable-line no-console
            $('.cart-error-box').empty().text('Unable to update item quantity');
        });

    return deferred;
};

ignition.load_cart_drawer = function load_cart_drawer() {
    var initial = document.querySelector('#initial-cart');
    if (!initial) {
        return;
    }
    var data = JSON.parse(initial.textContent);
    ignition.update_cart_drawer(data);

    $('.cart-button-checkout').on('click', function load_cart_drawer_checkout_click() {
        var $this = $(this);
        $this.find('.cart-button-checkout-text').addClass('hide');
        $this.find('.cart-button-checkout-spinner').removeClass('hide');
    });
};

// Flexslider Mobile Product Images

ignition.load_mobile_product_slider = function load_mobile_product_slider() {
    $('.mobile-product-slider').flexslider({
        animation: 'slide',
        directionNav: false,
        controlNav: true,
        startAt: 0,
        slideshow: false,
    });
};

// Flexslider in Indiv Product section

ignition.load_indiv_product_slider = function load_indiv_product_slider() {
    $('.homepage-sections--indiv-product-slider').flexslider({
        directionNav: false,
        slideshow: false,
        animation: 'slide',
    });
};

// Mobile menu hierarchy handling

function MobileMenu() {
    var self = this;
    this.menu_structure = JSON.parse(document.querySelector('#mobile-menu-data').textContent);
    var $menu = $('#mobile-menu');
    this.$submenu = $('#mobile-submenu');

    $('.mobile-menu-sub').off('click').on('click', function mobile_menu_sub_click() { self.menu_click($(this), $menu); });
    $('.mobile-menu-back').off('click').on('click', function mobile_menu_back_click() { self.back_click($(this)); });
}

ignition.MobileMenu = MobileMenu;

MobileMenu.prototype.menu_click = function menu_click($link, $menu) {
    var self = this;
    this.clear_submenus($menu);
    var handle = $link.data('link');

    if (handle === 'mobile-menu-currency') {
        $('#mobile-menu-currency').removeClass('mobile-menu-hidden');
        return;
    }

    this.menu_structure[handle].links.forEach(function menu_links_foreach(link) {
        var menu = self.menu_structure[link];
        var $li = $('<li></li>');
        var $a = $('<a></a>')
            .attr('href', menu.url)
            .html(menu.title);
        $li.append($a);
        if (menu.links.length > 0) {
            var $btn = $('<a href="#" class="mobile-menu-sub mobile-menu-right mobile-menu-link"><i data-feather="chevron-right" aria-hidden="true"></i></a>')
                .data('link', link)
                .on('click', function menu_links_click() { self.menu_click($(this), self.$submenu); });
            $li.append($btn);
        }
        $menu.append($li);
    });
    $menu.removeClass('mobile-menu-hidden');
    ignition.load_icons();
};

MobileMenu.prototype.clear_submenus = function clear_submenus($menu) {
    $menu.find('> li:not(:first)').remove();
};

MobileMenu.prototype.back_click = function back_click($link) {
    $link.parents('.mobile-menu').addClass('mobile-menu-hidden');
};

ignition.mobile_menu = null;

ignition.load_mobile_menu = function load_mobile_menu() {
    ignition.mobile_menu = new MobileMenu();

    $('select#mobile-menu').on('change', function mobile_menu_select_change() {
        window.location.href = $(this).find('option:selected').val().toString();
    });

    $('.mobile-menu-currency-link').on('click', function mobile_menu_currency_click() {
        var $this = $(this);
        var code = $this.data('code');
        $(document).trigger('currency:change', code);
    });

    $(document).on('currency:change', function mobile_menu_currency_change(event, currency) {
        // Select current currency in the mobile menu when global select changes
        $('.mobile-menu-currency-selected').removeClass('mobile-menu-currency-selected').find('svg').remove();
        $('.mobile-menu-currency-link[data-code=' + currency + ']').addClass('mobile-menu-currency-selected').append($('<i data-feather="check" aria-hidden="true"></i>'));
        ignition.load_icons();
    });
};

// Parallax effect for the Text over image section

function Parallax(target) {
    this.target = target;
    this.$target = $(target);
    this.img = target.querySelector('.img');
    this.active = false;

    // Wait for image load
    this.$target.children('.img').one('load', function paralax_img_load() {
        this.init();
        this.img.style.display = 'block';
    }.bind(this)).each(function parallax_each() {
        if (this.complete || !this.src) $(this).trigger('load');
    });

    window.addEventListener('scroll', this.update.bind(this), {
        capture: true,
        passive: true,
    });
    window.addEventListener('resize', this.init.bind(this));
}

ignition.Parallax = Parallax;

Parallax.prototype.init = function parallax_init() {
    this.img_height = $(this.img).height();
    this.container_height = (this.$target.height() > 0 ? this.$target.height() : this.img_height) || 500;

    // Parallax is disabled on mobile
    this.active = !window.matchMedia('screen and (max-width: 767px)').matches;
    this.update();
};

Parallax.prototype.update = function parallax_update() {
    if (!this.active) {
        this.img.style.transform = '';
        return;
    }
    var scrollTop = document.body.scrollTop || document.documentElement.scrollTop;

    var parallax_dist = this.img_height - this.container_height;
    var top = this.target.getBoundingClientRect().top + scrollTop;
    var bottom = top + this.container_height;
    var windowHeight = window.innerHeight;
    var windowBottom = scrollTop + windowHeight;
    var percentScrolled = (windowBottom - top) / (this.container_height + windowHeight);
    var parallax = parallax_dist * percentScrolled;

    if ((bottom > scrollTop) && (top < (scrollTop + windowHeight))) {
        this.img.style.transform = 'translate3D(-50%,' + parallax + 'px, 0)';
    }
};

ignition.parallaxes = [];

ignition.load_parallax = function load_parallax() {
    $('.parallax').each(function load_parallax_each() {
        ignition.parallaxes.push(new Parallax(this));
    });
};

ignition.load_mobile_text_adverts = function load_mobile_text_adverts() {
    $('.mobile-homepage-text-adverts').flexslider({
        controlNav: true,
        directionNav: false,
        animation: 'slide',
    });
};

ignition.load_search = function load_search() {
    $('.search-show').off('click').on('click', function search_show_click() {
        var $this = $(this);
        if ($this.closest('.sticky-header-wrapper').length > 0) {
            var $search = $('.sticky-header-search');
            $search.toggleClass('expanded');
            $search.find('#search_text').focus();
        } else {
            $('#top-search-wrapper').toggleClass('expanded');
            $('#top-search-wrapper #search_text').focus();
        }
        return false;
    });

    if ($(window).width() < 767) {
        $('.mobile-menu-close').trigger('click');
    }
};

ignition.dropdown_timeout = null;

ignition.dropdown_handle_hover = function dropdown_handle_hover() {
    // open menu/submenu on mousehover
    var $dropdown_toggle = $('.dropdown-ignition-toggle,.dropdown-menu');
    $dropdown_toggle.off('mouseenter').on('mouseenter', function dropdown_mouseenter() {
        var $this = $(this);

        // wait for some time before opening the menu
        var $menu = $this.parent();
        if (ignition.dropdown_timeout) {
            clearTimeout(ignition.dropdown_timeout);
        }
        ignition.dropdown_timeout = setTimeout(function dropdown_timeout() {
            // close other open menus
            if ($this.is('.dropdown-ignition-toggle')) {
                $('.dropdown.open,.dropdown-submenu.open').removeClass('open');
            }

            $menu.addClass('open');
            ignition.select_menu_direction($this.parent());
        }, 10);
    });

    // handle closing menu when hover ends
    $dropdown_toggle.off('mouseleave').on('mouseleave', function dropdown_mouseleave() {
        var $menu = $(this).parent();
        if (ignition.dropdown_timeout) {
            clearTimeout(ignition.dropdown_timeout);
        }
        ignition.dropdown_timeout = setTimeout(function dropdown_timeout() {
            $menu.removeClass('open');
        }, 50);
    });
};

ignition.dropdown_handle_touch = function dropdown_handle_touch() {
    // open menu when touched on touch device
    $('.dropdown-ignition-toggle').off('touchend').on('touchend', function dropdown_toggle_touchend(evt) {
        var $this = $(this);
        var $menu = $this.parent();
        if (!$menu.hasClass('open')) {
            evt.preventDefault();
            $menu.find('.dropdown-submenu.open').removeClass('open');
            $menu.addClass('open');
            ignition.select_menu_direction($menu);
        }
    });
    // open submenu when touched
    $('.dropdown-submenu').off('touchend').on('touchend', function dropdown_submenu_touchend(evt) {
        var $this = $(this);
        if (!$this.hasClass('open')) {
            evt.preventDefault();
            $('.dropdown-submenu.open').removeClass('open');
            $this.addClass('open');
        }
    });
    // hide menu when touched anywhere else then the menu
    $('body').on('touchstart', function dropdown_body_touchstart(evt) {
        var $open_menu = $('.dropdown.open');
        if ($open_menu.length === 0) {
            return;
        }
        // don't hide menu if we clicked "inside" the menu
        if ($(evt.target).parents('.dropdown.open').length === 0) {
            $open_menu.removeClass('open');
        }
    });
};

ignition.load_dropdown_hover = function load_dropdown_hover() {
    ignition.dropdown_handle_hover();
    ignition.dropdown_handle_touch();
};

ignition.select_menu_direction = function select_menu_direction($menu) {
    // Fix submenu opening outside of viewport by showing it to the left of menu
    var children_widths = $menu.find('.dropdown-menu .dropdown-menu').map(function dropdown_menu_map() {
        var $this = $(this);
        var width = $this.css({ display: 'block', visibility: 'hidden' }).outerWidth();
        $this.css({ display: '', visibility: '' });
        return width;
    });
    var max_width = Math.max.apply(null, children_widths);
    var $submenu = $menu.find('> .dropdown-menu');
    var left = $submenu.offset().left;
    var right = left + $submenu.outerWidth() + max_width;
    var switch_to_left = right > $('body').width() && left - max_width > 0;
    $submenu.toggleClass('dropdown-submenu-left', switch_to_left);
};

ignition.load_sticky_header = function load_sticky_header() {
    // We need to add some class to top level header div
    // as sticky and overlay is set inside it's parent container
    // and we can't dynamically change classes of section main element
    var $wrapper = $('.header-wrapper');
    if ($wrapper.hasClass('header-wrapper-sticky')) {
        $wrapper.parent().addClass('header-sticky');
    }
    if ($wrapper.hasClass('overlay-header-wrapper')) {
        $wrapper.parent().addClass('homepage-overlay');
    }

    window.stickybits('#shopify-section-header', {
        stickyClass: 'sticky',
        useStickyClasses: true,
    });
};

ignition.load_reviews = function load_reviews() {
    if (Object.hasOwnProperty.call(window, 'SPR') && document.querySelector('#shopify-product-reviews,.shopify-product-reviews-badge')) {
        window.SPR.registerCallbacks();
        window.SPR.initRatingHandler();
        window.SPR.initDomEls();
        window.SPR.loadProducts();
        window.SPR.loadBadges();
    }
};

ignition.load_collection_tag_filter = function load_collection_tag_filter() {
    /* Product Tag Filters - Good for any number of filters on any type of collection pages */
    var collFilters = $('.coll-filter');
    collFilters.on('change', function load_collection_tag_filter_change() {
        var newTags = [];
        collFilters.each(function load_collection_tag_filter_foreach() {
            var val = $(this).val();
            if (val) {
                newTags.push(val);
            }
        });
        if (newTags.length) {
            var query = newTags.join('+');
            window.location.href = $('#link-to-tag-generic a').attr('href').replace(/\/tag($|\?)/, '/' + query + '$1');
        } else {
            window.location.href = $('#link-to-collection').val().toString();
        }
    });
    collFilters.material_select();
};

ignition.queryParams = {};

ignition.load_collection_sort = function load_collection_sort() {
    if (window.location.search.length) {
        for (var aKeyValue, i = 0, aCouples = window.location.search.substr(1).split('&'); i < aCouples.length; i += 1) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
                ignition.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
        }
    }

    var sort_by = $('#collection-sort-by').val();
    var $sort_by = $('#sort-by');
    $sort_by.val(sort_by)
        .on('change', function sort_by_change() {
            ignition.queryParams.sort_by = $(this).val();
            window.location.search = $.param(ignition.queryParams).replace(/\+/g, '%20');
        });
    $sort_by.material_select();
};

ignition.load_collection_mobile_sidebar = function load_collection_mobile_sidebar() {
    $('.collection-sidebar--section h2').on('click', function load_collection_mobile_sidebar_click() {
        var $this = $(this);
        var parent = $this.parent();
        parent.toggleClass('expanded');
    });
};

// Video section

ignition.is_scrolled_into_view = function is_scrolled_into_view($element) {
    var $w = $(window);
    var docViewTop = $w.scrollTop();
    var docViewBottom = docViewTop + $w.height();

    var elemCenter = $element.offset().top + $element.outerHeight() / 2.0;

    return ((elemCenter >= docViewTop && elemCenter <= docViewBottom));
};

var insideViewCheckTimeout = null,
    wasInsideView = false;

ignition.visibility_tracker = function visibility_tracker($element, scrolled_into_view_cb, scrolled_out_of_view_cb) {
    wasInsideView = ignition.is_scrolled_into_view($element);
    if (wasInsideView) {
        scrolled_into_view_cb();
    }

    $(window).on('scroll,resize', function visibility_tracker_update() {
        ignition.check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb);
    });

    ignition.check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb);
};

ignition.check_inside_view = function check_inside_view($element, scrolled_into_view_cb, scrolled_out_of_view_cb) {
    if (insideViewCheckTimeout) {
        clearTimeout(insideViewCheckTimeout);
    }
    insideViewCheckTimeout = setTimeout(function check_inside_view_timer() {
        insideViewCheckTimeout = null;

        var isInsideView = ignition.is_scrolled_into_view($element);

        if (wasInsideView && !isInsideView) {
            scrolled_out_of_view_cb();
        }

        if (!wasInsideView && isInsideView) {
            scrolled_into_view_cb();
        }
        wasInsideView = isInsideView;
    }, 100);
};

ignition.youtubes = [];

ignition.load_youtube = function load_youtube(element) {
    var autoplay = element.dataset.videoAutoplay === 'true',
        mute = element.dataset.videoMute === 'true',
        loop = element.dataset.videoLoop === 'true',
        $element = $(element),
        $parent = $(element).parent(),
        $overlay = $element.closest('.video-section').find('.video-overlay');

    ignition.youtubes.push(new window.YT.Player(element.id, {
        width: 746,
        videoId: element.dataset.videoLink,
        playerVars: {
            showinfo: 0,
            modestbranding: 1,
            rel: 0,
        },
        events: {
            onReady: function youtube_onready(event) {
                var video = event.target;
                if (autoplay) {
                    $parent.data('pausedAutomatically', true);
                }
                if (mute) {
                    video.mute();
                }

                ignition.visibility_tracker(
                    $parent,
                    function scrolled_into_view() {
                        if ($parent.data('pausedAutomatically')) {
                            video.playVideo();
                        }
                    },
                    function scrolled_out_of_view() {
                        $overlay.removeClass('active');
                        if (video.getPlayerState() === window.YT.PlayerState.PLAYING) {
                            $parent.data('pausedAutomatically', true);
                            video.pauseVideo();
                        }
                    },
                );
            },
            onStateChange: function youtube_on_state_change(event) {
                if (event.data === window.YT.PlayerState.PLAYING) {
                    if (!autoplay) {
                        $overlay.addClass('active');
                    }
                    $parent.data('pausedAutomatically', false);
                }

                if (event.data === window.YT.PlayerState.ENDED && loop) {
                    event.target.playVideo();
                }
            },
        },
    }));
};

ignition.load_youtube_all = function load_youtube_all() {
    $('.youtube-video').each(function load_youtube_each(index, el) {
        ignition.load_youtube(el);
    });
};

ignition.load_youtube_api = function load_youtube_api() {
    if (!document.querySelector('.youtube-video')) {
        // No youtube elements, do not load youtube API
        return;
    }

    if (!document.querySelector('#youtube_api')) {
        // Youtube API is not yet loaded, create script that loads it
        ignition.create_script('youtube_api', 'https://www.youtube.com/player_api');

        // Call 'youtube_load_all' as soon as the API is loaded
        window.onYouTubePlayerAPIReady = ignition.load_youtube_all;
    } else if (!window.YT) {
        // Script for loading youtube API is there, but youtube is not yet loaded,
        // load_youtube_all will be called when script finishes loading
    } else {
        // We already have youtube API loaded, call 'load_youtube_all'
        ignition.load_youtube_all();
    }
};

ignition.load_vimeo = function load_vimeo(element) {
    var player = new window.Vimeo.Player(element.id);
    player.ready().catch(function vimeo_error(e) {
        document.getElementById(element.id).innerText = e;
    });
    if (element.dataset.videoMute === 'true') {
        player.setVolume(0);
    }
    var autoplay = element.dataset.videoAutoplay === 'true';
    if (autoplay) {
        $(element.parentNode).data('pausedAutomatically', true);
    }

    var $element = $(element),
        $parent = $element.parent(),
        $overlay = $element.closest('.video-section').find('.video-overlay');

    ignition.visibility_tracker(
        $parent,
        function scrolled_into_view() {
            if ($parent.data('pausedAutomatically')) {
                player.play();
            }
        },
        function scrolled_out_of_view() {
            $overlay.removeClass('active');
            player.getPaused().then(function vimeo_on_pause(paused) {
                if (!paused) {
                    player.getEnded().then(function vimeo_on_ended(ended) {
                        if (!ended) {
                            $parent.data('pausedAutomatically', true);
                            player.pause();
                        }
                    });
                }
            });
        },
    );
    player.on('play', function vimeo_on_play() {
        if (!autoplay) {
            $overlay.addClass('active');
        }
        $parent.data('pausedAutomatically', false);
    });
};

ignition.load_vimeo_all = function load_vimeo_all() {
    $('.vimeo-video').each(function load_vimeo_each(index, el) {
        ignition.load_vimeo(el);
    });
};

ignition.load_vimeo_api = function load_vimeo_api() {
    if (!document.querySelector('.vimeo-video')) {
        // No vimeo elements, do not load vimeo API
        return;
    }

    if (!document.querySelector('#vimeo_api')) {
        // Vimeo API is not yet loaded, create script that loads it
        var script = ignition.create_script('vimeo_api', 'https://player.vimeo.com/api/player.js');

        if (script.readyState) {
            // IE
            script.onreadystatechange = function vimeo_script_load_ie() {
                if (script.readyState === 'loaded' || script.readyState === 'complete') {
                    script.onreadystatechange = null;
                    ignition.load_vimeo_all();
                }
            };
        } else {
            // Other browsers
            script.onload = function vimeo_script_load() {
                ignition.load_vimeo_all();
            };
        }
    } else if (!window.Vimeo) {
        // Script for loading vimeo API is there, but vimeo is not yet loaded,
        // load_vimeo_all will be called when script finishes loading
    } else {
        // We already have vimeo API loaded, call 'load_vimeo_all'
        ignition.load_vimeo_all();
    }
};

ignition.create_script = function create_script(id, src) {
    var tag = document.createElement('script');
    tag.id = id;
    tag.src = src;
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    return tag;
};

ignition.load_password_recover = function load_password_recover() {
    var $recover = $('.recover-form');
    if ($recover.length === 0) {
        return;
    }
    $recover.removeClass('no-js');
    if (window.location.hash !== '#recover') {
        $recover.addClass('hide');
    }
    $('.show-password-form').on('click', function load_password_recover_click() {
        $recover.toggleClass('hide');
    });
};

ignition.show_alert = function show_alert($content) {
    $('<div class="page-alert"></div>').append($content.clone()).appendTo('body');
};

ignition.load_newsletter_form = function load_newsletter_form() {
    // Use AJAX for submitting the contact form
    $('.contact-form').off('submit').on('submit', function newsletter_form_submit(event) {
        event.preventDefault();
        var $form = $(this);
        $form.find('.newsletter-spinner').removeClass('hide');
        $form.find('.newsletter-wrapper').addClass('hide');

        $.post('/contact', $form.serialize())
            .done(function load_newsletter_form_done() {
                $form.find('.form-success').removeClass('hide');
                $form.find('.newsletter-spinner').addClass('hide');
            })
            .fail(function load_newsletter_form_fail() {
                $form.off('submit');
                $form.submit();
            });
    });
    var $success = $('.contact-form .form-success');
    var $errors = $('.contact-form .errors');
    if ($errors.length > 0 && $errors.children().length > 0) {
        ignition.show_alert($errors.eq(0));
    } else if ($success.length > 0) {
        ignition.show_alert($success.eq(0));
    }
};

ignition.make_video_embed_responsive = function make_video_embed_responsive() {
    $('.template-page iframe, .template-blog iframe, .template-article iframe').each(function iframe_each(index, iframe) {
        var source = $(iframe).attr('src');

        if (source.indexOf('youtube.com') >= 0 || source.indexOf('vimeo.com') >= 0 || source.indexOf('dailymotion.com') >= 0) {
            // create container
            var embedContainer = document.createElement('div');
            $(embedContainer).addClass('embed-container');

            // clone iframe
            var iframeClone = $(iframe).clone();

            // put clone in container
            $(embedContainer).append(iframeClone);

            // embed clone with responsive container
            $(iframe).replaceWith(embedContainer);
        }
    });
};

ignition.on_variant_unavailable = function on_variant_unavailable(evt) {
    if ($('.product-page--submit-action').data('stock-email-enabled')) {
        var productTitle = $('.product-description-header').text();
        var $outOfStockEmailBody = $('#notify-me-wrapper input[name="contact[body]"]');
        var $emailString = 'Please notify me when ' + productTitle + ', variant: ' + evt.variant.title + ' becomes available.';
        $outOfStockEmailBody.val($emailString);
        $('.variant-out-of-stock').fadeIn();
        $('.product-page--submit-action').addClass('hidden');
    }
};

ignition.on_variant_available = function on_variant_available() {
    if ($('.product-page--submit-action').data('stock-email-enabled')) {
        $('.variant-out-of-stock').hide();
        $('.product-page--submit-action').removeClass('hidden');
    }
};

ignition.load_out_of_stock_email_form = function load_out_of_stock_email_form() {
    $('#notify-me a').on('click', function notify_me_click() {
        if ($('customer_notify').val().toString() === '0') {
            $('#sold-out form').submit();
        } else {
            $('#notify-me-wrapper').fadeIn();
        }
        return false;
    });

    $(document).on('variantUnavailable', ignition.on_variant_unavailable);

    $(document).on('variantAvailable', ignition.on_variant_available);
};

ignition.load_materialize_select = function load_materialize_select() {
    $('select.materialize').material_select();
};

ignition.load_accordion = function load_accordion() {
    var acc = document.getElementsByClassName('accordion');
    var i;
    for (i = 0; i < acc.length; i += 1) {
        acc[i].addEventListener('click', function accordion_click() {
            var wasActive = this.classList.contains('active');

            // Remove all `active` from headers and bodies
            Array.prototype.forEach.call(
                document.querySelectorAll('.accordion.active, .accordion-content.active'),
                function accordion_active(el) {
                    el.classList.remove('active');
                },
            );

            if (!wasActive) {
                // Make clicked section active
                this.classList.add('active');
                var panel = this.nextElementSibling;
                panel.classList.add('active');
            }
        });
    }
};

ignition.load_quantity_controls = function load_quantity_controls() {
    $('.quantity-controls button.qty-plus').off().on('click', function quantity_controls_plus(e) {
        e.preventDefault();
        var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
        qtyInput.val(parseInt(qtyInput.val().toString(), 10) + 1);
    });

    $('.quantity-controls button.qty-minus').off().on('click', function quantity_controls_minus(e) {
        e.preventDefault();
        var qtyInput = $(this).closest('.quantity-controls').find('input.quantity-selector');
        var qty = parseInt(qtyInput.val().toString(), 10);
        var newQty = (qty - 1 < 1) ? 1 : (qty - 1);
        qtyInput.val(newQty);
    });
};

ignition.load_terms_check = function load_terms_check() {
    var selector = '[name="checkout"], [name="goto_pp"], [name="goto_gc"]';
    $('body').off('click', selector, ignition.check_terms).on('click', selector, ignition.check_terms);
};

ignition.check_terms = function check_terms() {
    var $this = $(this);
    var $form = $this.closest('form');
    var $agree = $form.find('#agree');
    if ($agree.length === 0 || $agree.is(':checked')) {
        $this.submit();
    } else {
        alert(ignition.strings.terms_agree); // eslint-disable-line no-alert
        $form.find('.cart-button-checkout-text').removeClass('hide');
        $form.find('.cart-button-checkout-spinner').addClass('hide');
        return false;
    }
    return null;
};

ignition.load_responsive_tables = function load_responsive_tables() {
    $('.product-description-wrapper table').wrap('<div class="rte__table-wrapper"></div>');
};

ignition.load_fancybox = function load_fancybox() {
    $('.fancybox').fancybox();
    $('.fancybox-instagram').fancybox({
        padding: 0,
    });
};

ignition.load_login_boxes = function load_login_boxes() {
    $('#forgot-password-box').on('click', function forgot_password_click() {
        $('#customer-login').hide();
        $('#recover-password').show();
    });

    $('#login-box-link').on('click', function login_box_click() {
        $('#customer-login').show();
        $('#recover-password').hide();
    });
};

// Drawers

ignition.MOBILE_DRAWER_SIZE = 300;
ignition.DESKTOP_DRAWER_SIZE = 390;
ignition.MOBILE_WIDTH_MAX = 990;

ignition.slideouts = {};


// Simulate responsiveness of the Drawer component
ignition.drawers_window_resize = function drawers_window_resize() {
    var is_mobile = document.body.clientWidth < ignition.MOBILE_WIDTH_MAX;

    // Disable mobile drawer on desktop
    ignition.slideouts.left._touch = is_mobile; // eslint-disable-line no-underscore-dangle

    if (!ignition.slideouts.right) {
        // cart slider is disabled
        return;
    }

    // Resize right drawer based on window width
    var slideout = ignition.slideouts.right,
        padding = (is_mobile) ? ignition.MOBILE_DRAWER_SIZE : ignition.DESKTOP_DRAWER_SIZE,
        orientation = slideout._orientation; // eslint-disable-line no-underscore-dangle
    slideout._padding = padding * orientation; // eslint-disable-line no-underscore-dangle
    slideout._translateTo = slideout.ignition.padding; // eslint-disable-line no-underscore-dangle
    if (slideout._opened) { // eslint-disable-line no-underscore-dangle
        var transform = 'translateX(' + (padding * orientation) + 'px)';
        slideout.ignition.panel.style.webkitTransform = transform;
        slideout.ignition.panel.style.transform = transform;
    }
};

$(window).on('resize', ignition.drawers_window_resize);

ignition.slideout_touchstart = function slideout_touchstart(event) {
    if (!this.isOpen()) {
        return;
    }
    event.preventDefault();
    this.ignition.touch_start = event.touches[0].pageX;
};

ignition.slideout_touchmove = function slideout_touchmove(event) {
    if (!this.isOpen()) {
        return;
    }
    var offset = this.ignition.touch_start - event.touches[0].pageX;
    var translate = (this.ignition.dir * this.ignition.padding) - offset;
    if (Math.abs(translate) > this.ignition.padding) {
        translate = (this.ignition.dir * this.ignition.padding);
    }
    this.ignition.panel.style.webkitTransform = 'translateX(' + translate + 'px)';
    this.ignition.panel.style.transform = 'translateX(' + translate + 'px)';
};

ignition.slideout_touchend = function slideout_touchend(event) {
    if (!this.isOpen()) {
        return;
    }
    var offset = this.ignition.touch_start - event.changedTouches[0].pageX;
    if (offset === 0 || Math.abs(offset) > 70) {
        this.close(this);
    } else {
        this.ignition.panel.style.webkitTransform = 'translateX(' + (this.ignition.dir * this.ignition.padding) + 'px)';
        this.ignition.panel.style.transform = 'translateX(' + (this.ignition.dir * this.ignition.padding) + 'px)';
    }
};

ignition.slideout_before_open = function slideout_before_open() {
    this.ignition.menu.classList.remove('slideout-panel-hidden');
    if (this.ignition.hidden_menu) {
        this.ignition.hidden_menu.classList.add('slideout-panel-hidden');
    }
    $(this.ignition.overlay).fadeIn();
    // document.body.style.overflowY = 'hidden';
    var marginTop = $(window).scrollTop() + 'px';
    this.ignition.panel.style.position = 'fixed';
    this.ignition.panel.style.marginTop = '-' + marginTop;
    // Apply opposite effect to the sticky header
    $('.sticky-header-wrapper.sticky').css({
        'margin-top': marginTop,
        transform: 'translateY(0)',
    });
};

ignition.slideout_before_close = function slideout_before_close() {
    $(this.ignition.overlay).fadeOut();

    var scrollTop = -parseInt(this.ignition.panel.style.marginTop, 10);
    this.ignition.panel.style.position = '';
    this.ignition.panel.style.marginTop = '';
    $(window).scrollTop(scrollTop);
};

ignition.slideout_close = function slideout_close() {
    $('.sticky-header-wrapper').css({
        'margin-top': 0,
        transform: '',
    });
    this.ignition.menu.classList.add('slideout-panel-hidden');
};

ignition.slideout_translate = function slideout_translate(translated) {
    var hidden = false;
    if (translated === 0) {
        hidden = true;
    } else if (this.ignition.side === 'left') {
        hidden = translated <= 0;
    } else if (this.ignition.side === 'right') {
        hidden = translated >= 0;
    }
    this.ignition.menu.classList.toggle('slideout-panel-hidden', hidden);
    if (this.ignition.hidden_menu) {
        this.ignition.hidden_menu.classList.toggle('slideout-panel-hidden', !hidden);
    }
};

ignition.create_drawer = function create_drawer(side, panel, menu, hidden_menu, overlay) {
    var padding = ignition.MOBILE_DRAWER_SIZE;
    if (side === 'right' && document.body.clientWidth >= ignition.MOBILE_WIDTH_MAX) {
        padding = ignition.DESKTOP_DRAWER_SIZE;
    }

    var slideout = new window.Slideout({
        panel: panel,
        menu: menu,
        padding: padding,
        tolerance: 70,
        side: side,
        touch: false,
    });
    slideout.ignition = {
        dir: (side === 'right') ? -1 : 1,
        menu: menu,
        hidden_menu: hidden_menu,
        overlay: overlay,
        touch_start: null,
        side: side,
        panel: panel,
        padding: padding,
    };
    ignition.slideouts[side] = slideout;
    menu.classList.add('slideout-panel-hidden');

    overlay.addEventListener('click', slideout.close.bind(slideout));

    overlay.addEventListener('touchstart', ignition.slideout_touchstart.bind(slideout));
    overlay.addEventListener('touchmove', ignition.slideout_touchmove.bind(slideout));
    overlay.addEventListener('touchend', ignition.slideout_touchend.bind(slideout));

    slideout.on('beforeopen', ignition.slideout_before_open.bind(slideout));

    slideout.on('beforeclose', ignition.slideout_before_close.bind(slideout));

    slideout.on('close', ignition.slideout_close.bind(slideout));
    slideout.on('translate', ignition.slideout_translate.bind(slideout));

    return slideout;
};

ignition.load_menu_drawer = function load_menu_drawer(event) {
    if (event && event.detail && event.detail.sectionId === 'footer') {
        // Shopify doesn't correctly handle scrolling to footer on section change because the section
        // has zero height when it's scrolled to but when it loads it gets out of visible area
        setTimeout(function menu_drawer_footer() {
            // Scroll to the footer element after loading
            var top = document.body.clientHeight;
            document.documentElement.scrollTop = top;
            document.body.scrollTop = top;
        }, 0);
    }

    // Close sliders if they're open
    if (ignition.slideouts && ignition.slideouts.left) {
        ignition.slideouts.left.close();
    }
    if (ignition.slideouts && ignition.slideouts.right) {
        ignition.slideouts.right.close();
    }

    /* Move mobile menu out of section to document body because the slideout
       needs to put it to the sidebar, but it can't be in the body from the beginning
       because it needs section config */
    var body_menu = $('body > #menu');
    var main_body_menu = $('#main-body #menu');
    if (main_body_menu.length > 0) {
        body_menu.remove();
        $('body').append(main_body_menu);
    }

    var main_body = document.querySelector('#main-body');
    var left_menu = document.querySelector('#menu');
    var right_menu = document.querySelector('#cartSlideoutWrapper');
    var overlay = document.querySelector('#slideout-overlay');

    /* Mobile Menu */

    var slideoutLeft = ignition.create_drawer('left', main_body, left_menu, right_menu, overlay);

    $('.slide-menu-mobile').off('click').on('click', function slideout_mobile_click() {
        slideoutLeft.toggle();
    });

    $('.mobile-menu-close').on('click', function slideout_mobile_close() {
        slideoutLeft.close();
    });

    // Disable mobile drawer on desktop
    if (document.body.clientWidth >= ignition.MOBILE_WIDTH_MAX) {
        slideoutLeft.ignition.touch = false;
    }

    // Add events for sidebar manipulation from outside
    $(left_menu)
        .on('mobile:toggle', slideoutLeft.toggle.bind(slideoutLeft))
        .on('mobile:open', slideoutLeft.open.bind(slideoutLeft))
        .on('mobile:close', slideoutLeft.close.bind(slideoutLeft));

    /* Cart */
    if (!right_menu) {
        // Cart drawer is disabled in the settings
        return;
    }
    var slideoutRight = ignition.create_drawer('right', main_body, right_menu, left_menu, overlay);

    // Toggle button
    $('.slide-menu-cart').off('click').on('click', function slideout_cart_click(e) {
        slideoutRight.toggle();
        // prevent non-ajax basket
        e.preventDefault();
        return false;
    });

    $('.cart-menu-close').on('click', function slideout_cart_close() {
        slideoutRight.close();
    });

    // Add events for sidebar manipulation from outside
    $(right_menu)
        .on('cart:toggle', slideoutRight.toggle.bind(slideoutRight))
        .on('cart:open', slideoutRight.open.bind(slideoutRight))
        .on('cart:close', slideoutRight.close.bind(slideoutRight));
};

// Google Maps JS

// Set map Variables
ignition.MAP_SELECTOR = '.map-wrapper';
ignition.MAP_API_FAILED = false;
ignition.map_objects = [];

ignition.set_map_error = function set_map_error(message, container) {
    if (!container) {
        container = $('.map-section__container');
    }
    container.addClass('hide');
    if (window.Shopify.designMode) {
        $('<div class="map-container-error"></div>').text(message).appendTo(container.parent().find('.map-section__overlay'));
    }
    container.parent().find('.homepage-map--fallback').removeClass('hide');
};

ignition.maps_resize = function maps_resize() {
    // Center map when screensize is changed
    ignition.map_objects.forEach(function map_objects_resize(map) {
        var currCenter = map.getCenter();
        window.google.maps.event.trigger(map, 'resize');
        map.setCenter(currCenter);
    });
};

ignition.map_init = function map_init(map_element) {
    var config = {
        zoom: 14,
    };

    var section = map_element.dataset.id;
    var style = [];
    try {
        style = JSON.parse(document.getElementById('homepage-map--theme--' + section).textContent);
    } catch (e) {
        console.error('Unable to parse theme style:', e); // eslint-disable-line no-console
    }
    var container = document.querySelector('#map-container-' + section);
    if (!container) {
        return;
    }
    var $container = $(container);
    if (ignition.MAP_API_FAILED) {
        ignition.set_map_error('Google Maps authentication error, API key might be invalid', $container);
    }

    var map = new window.google.maps.Map(container, {
        zoom: config.zoom,
        styles: style,
        disableDefaultUI: true,
        draggable: false,
        clickableIcons: false,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        draggableCursor: 'default',
    });
    ignition.map_objects.push(map);

    var geocoder = new window.google.maps.Geocoder();

    ignition.geocode_address(geocoder, map, section, $container);
};

ignition.google_markers = [];

ignition.geocode_address = function geocode_address(geocoder, resultsMap, section, $container) {
    var address = $('#map-container-' + section).data('address-setting');
    geocoder.geocode({ address: address }, function on_geocode(results, status) {
        if (status === 'OK') {
            resultsMap.setCenter(results[0].geometry.location);
            ignition.google_markers.push(new window.google.maps.Marker({
                map: resultsMap,
                position: results[0].geometry.location,
            }));
        } else {
            ignition.set_map_error('Error looking up that address', $container);
        }
    });
};

// Google Map JS
ignition.load_googlemaps = function load_googlemaps() {
    var mapElements = document.querySelectorAll(ignition.MAP_SELECTOR);
    if (mapElements.length === 0) {
        // No map element on the page, don't load the map API
        return;
    }

    var apiKey = null;
    Array.prototype.forEach.call(mapElements, function googlemap_foreach(map_element) {
        var section = map_element.dataset.id;
        /** @type HTMLInputElement */
        var el = document.querySelector('#apikey-' + section);
        var elementApiKey = el.value;
        if (!elementApiKey) {
            return;
        }
        if (apiKey && elementApiKey && elementApiKey !== apiKey) {
            console.warn('Multiple different Google Maps API keys are not allowed, using only the first one'); // eslint-disable-line no-console
            return;
        }
        apiKey = elementApiKey;
    });
    if (!apiKey) {
        console.error('Google Maps API key not provided!'); // eslint-disable-line no-console
        ignition.set_map_error('Google Maps API key not provided!', null);
        return;
    }

    if (ignition.MAP_API_FAILED || !window.google || !window.google.maps || !window.google.maps.Geocoder || !window.google.maps.Map) {
        ignition.MAP_API_FAILED = false;
        $.getScript(
            'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&callback=google_maps_loaded',
        );
    } else {
        window.google_maps_loaded();
    }
};

window.google_maps_loaded = function google_maps_loaded() {
    Array.prototype.forEach.call(document.querySelectorAll(ignition.MAP_SELECTOR), ignition.map_init);
    $(window).off('resize', ignition.maps_resize).on('resize', ignition.maps_resize);
};

// Global function called by Google on auth errors.
// Show an auto error message on all map instances.
// eslint-disable-next-line camelcase, no-unused-vars

window.gm_authFailure = function gm_authFailure() {
    ignition.MAP_API_FAILED = true;
    console.error('Authentication Failure'); // eslint-disable-line no-console

    ignition.set_map_error('Google Maps authentication error, API key might be invalid', null);
};

ignition.search_overlay_close = function search_overlay_close() {
    $('#search-overlay').fadeOut();
};

ignition.search_overlay_open = function search_overlay_open() {
    $('#search-overlay').fadeIn().find('#search-text').focus();

};

ignition.search_overlay_click = function search_overlay_click(e) {
    // Only close the overlay when the overlay element is clicked, not children
    if (e.target.id === 'search-overlay') {
        ignition.search_overlay_close();
    }
};

ignition.search_overlay_keyup = function search_overlay_keyup(e) {
    // Handle Escape key
    if (e.keyCode === 27) {
        ignition.search_overlay_close();
    }
};

ignition.load_search_overlay = function load_search_overlay() {
    $('#search-overlay').click(ignition.search_overlay_click);
    $('.close-btn').click(ignition.search_overlay_close);
    $('#search-btn').click(ignition.search_overlay_open);
    $('#search-text').on('keyup', ignition.search_overlay_keyup);
};

// Initialization

ignition.block_select = function block_select(event) {
    // Stop animation and show block when selected in the Slideshow section
    var slider = ignition.sliders[event.detail.sectionId],
        index;

    if (slider) {
        index = parseInt(event.target.dataset.slideIndex, 10);
        slider.show_slide(index);
    }

    var testimonial = ignition.testimonials[event.detail.sectionId];
    if (testimonial) {
        index = parseInt(event.target.dataset.slideIndex, 10);
        testimonial.show_slide(index);
    }

    var announcement = ignition.announcements[event.detail.sectionId];
    if (announcement) {
        index = parseInt(event.target.dataset.slideIndex, 10);
        announcement.show_slide(index);
    }

    // Stop animation and show block when select in Text Adverts section on mobile
    var mobile_text_advert = $(event.target).parents('.homepage-sections-wrapper').find('.mobile-homepage-text-adverts');
    if (mobile_text_advert.length > 0) {
        var i = Array.prototype.indexOf.call(event.target.parentElement.children, event.target);
        mobile_text_advert.flexslider('stop');
        mobile_text_advert.flexslider(i);
    }

    // Open megamenu which is being edited (both normal menu and sticky menu)
    if (event.target.dataset.megaMenuBlockId) {
        $('#shopify-section-header').addClass('force-hover');
        $('[data-mega-menu-block-id=' + event.target.dataset.megaMenuBlockId + ']').closest('li.dropdown').addClass('force-open');
    }

    // Open product tab that's being edited
    if (event.target.classList.contains('accordion')) {
        Array.prototype.forEach.call(
            event.target.parentNode.querySelectorAll('.accordion.active,.accordion-content.active'),
            function accordion_active_each(el) {
                el.classList.remove('active');
            },
        );
        event.target.classList.add('active');
        event.target.nextElementSibling.classList.add('active');
    }
};

ignition.block_deselect = function block_deselect(event) {
    // Resume animation when block is deselected in the Slideshow section
    var slider = ignition.sliders[event.detail.sectionId];
    if (slider) {
        slider.start_animation();
    }

    var testimonial = ignition.testimonials[event.detail.sectionId];
    if (testimonial) {
        testimonial.start_animation();
    }

    var announcement = ignition.announcements[event.detail.sectionId];
    if (announcement) {
        announcement.start_animation();
    }

    // Resume animation when block is deselected in Text Adverts section on mobile
    var mobile_text_advert = $(event.target).parents('.homepage-sections-wrapper').find('.mobile-homepage-text-adverts');
    if (mobile_text_advert.length > 0) {
        mobile_text_advert.flexslider('play');
    }

    // Close opened megamenus
    $('li.dropdown.force-open').removeClass('force-open');
    $('#shopify-section-header').removeClass('force-hover');
};

ignition.get_section_name = function get_section_name(event) {
    var section = null;
    if (event && event.detail) {
        var data = {};
        var dataset = event.target.dataset;
        Object.keys(dataset).forEach(function section_data_foreach(key) {
            if (Object.hasOwnProperty.call(dataset, key) && key.indexOf('themeEditorSection-') === 0) {
                data = JSON.parse(dataset[key]);
            }
        });
        if (Object.hasOwnProperty.call(data, 'type')) {
            section = data.type;
        }
    }
    return section;
};

ignition.show_unauthorized = function show_unauthorized() {
    $(document.body)
        .empty()
        .append(
            $('<div class="ignition-unautorized">You are not authorized to use this theme, please open the application to check the reason</div>'),
        );
};

ignition.onload_with_check = function onload_with_check(event) {
    document.addEventListener('shopify:block:select', ignition.block_select);
    document.addEventListener('shopify:block:deselect', ignition.block_deselect);

    if (window.Shopify.designMode) {
        return $.ajax({
            method: 'GET',
            url: '/apps/ignition/check',
        })
            .done(function onload_check_done() {
                return ignition.onload(event);
            })
            .fail(function onload_check_fail() {
                return ignition.show_unauthorized();
            });
    } else {
        return ignition.onload(event);
    }
};

ignition.onload = function onload(event) {
    // Init Feather Icon Lib
    ignition.load_icons();

    // Wow Animation init
    (new window.WOW()).init();

    var section = ignition.get_section_name(event);
    if (!section || section === 'testimonials') {
        // Do not reload slider when header or footer is changed
        ignition.load_testimonial(event && event.target);
    }

    if (!section || section === 'slideshow') {
        // Do not reload slider when header or footer is changed
        ignition.load_slider(event && event.target);
    }

    if (!section || section === 'instagram') {
        ignition.load_instagram(event ? event.target : document.body);
    }

    if (!section || section === 'product-template' || section === 'indiv-product') {
        ignition.load_zoom();
        ignition.load_tabs();
        ignition.load_mobile_product_slider();
        ignition.load_indiv_product_slider();
        ignition.load_quantity_controls();
        ignition.load_out_of_stock_email_form();
        ignition.load_product(section && event && event.target);
        ignition.load_materialize_select();
        ignition.load_accordion();
    }

    if (!section || section === 'header') {
        ignition.load_search();
        ignition.load_sticky_header();
        ignition.load_mobile_menu();
        ignition.load_dropdown_hover();
        ignition.load_menu_drawer(event);
        ignition.load_search_overlay();
    }

    if (!section || section === 'text-adverts') {
        ignition.load_mobile_text_adverts();
    }

    if (!section || section === 'text-over-image') {
        ignition.load_parallax();
    }

    if (!section || section === 'collection-template') {
        ignition.load_collection_tag_filter();
        ignition.load_collection_sort();
        ignition.load_collection_mobile_sidebar();
    }

    if (!section || section === 'list-collections' || section === 'collection' || section === 'collection-template' || section === 'product-template' || section === 'indiv-product') {
        if (event) {
            // The Shopify Product Review app will load itself on document load,
            // we need to apply it manually when product section change
            ignition.load_reviews();
        }
    }

    if (!section || section === 'cart-template') {
        ignition.load_quantity_controls();
        ignition.load_terms_check();
    }
    if (!section || section === 'video') {
        ignition.load_youtube_api();
        ignition.load_vimeo_api();
    }

    if (!section || section === 'map') {
        ignition.load_googlemaps();
    }

    if (!section) {
        ignition.load_password_recover();
    }
    ignition.load_announcement_bar();
    ignition.load_newsletter_form();
    ignition.load_cart_drawer();
    ignition.make_video_embed_responsive();
    ignition.load_materialize_select();
    ignition.load_out_of_stock_email_form();
    ignition.load_quantity_controls();
    ignition.load_responsive_tables();
    ignition.load_fancybox();
    ignition.load_login_boxes();
};

ignition.onunload = function onunload() {
    document.removeEventListener('shopify:block:select', ignition.block_select);
    document.removeEventListener('shopify:block:deselect', ignition.block_deselect);
    ignition.sliders = {};
};

document.addEventListener('shopify:section:load', ignition.onload_with_check);
document.addEventListener('shopify:section:unload', ignition.onunload);
}(window.ignition.$, window.ignition));
